
export class BaseAttribute  {
       protected paramCheck(param:any):any {
            if ( param && param.length >= 0  ) {
                  if ( param.charAt(0) == '{' ) {
                       param = eval("("+param+")");
                  }
            }          
            return param;
       }

       protected ifCheck(text:string, where:any, generalIf:any):string {

            if ( text && text.endsWith("$") ) {

                 if ( where === undefined  ) where = generalIf;

                 if ( where !== undefined  ) {

                       if ( typeof where == 'string' ) {
                             if ( where ) text += where;
                       }
                       else
                       if ( where )  text += "Y";
                       else          text += "N";
                 }
            }
            return text;
       }
}